import React from "react";
import { FCard } from ".";
import { Box, Chip, Tooltip, Typography } from "@mui/material";
import { StatProgressBar } from "../progress-bar/StatProgressBar";
import { highlightText } from "../../utils/highlightText";
import { smartTruncateString } from "../../utils/smartTruncation";
import { formatPercent } from "../../utils/numberFormat";
const STATUS_STYLES = {
    info: { color: "#006C9C", backgroundColor: "#00B8D929" },
    success: { color: "#54801A", backgroundColor: "#86B84529" },
    warning: { color: "#776304", backgroundColor: "#FBE67E66" },
    primary: { color: "#2476A9", backgroundColor: "#3192D026" },
};
const getStatusColor = (status) => {
    const s = status.toLowerCase().trim();
    if (s === "afgerond")
        return "success";
    if (s === "nog te doen")
        return "warning";
    if (s === "nieuw")
        return "info";
    return "primary";
};
const fmtNumber = (n) => n != null
    ? n.toLocaleString("nl-NL", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })
    : "—";
export const ProjectCard = ({ projectName, projectNumber, projectLeadName, projectStatus, omzet, aanneemsom, forecastMargin, onClick, percent, searchTerm, isSearchResult = false, }) => {
    // Mirrors the desktop grid, which shows Projectleider rather than the entity,
    // down to the "N/A" it shows for a project the data lake has no lead for.
    const subtitle = [projectNumber, (projectLeadName !== null && projectLeadName !== void 0 ? projectLeadName : "").trim() || "N/A"]
        .filter(Boolean)
        .join(" • ");
    return (React.createElement(FCard, { onClick: onClick },
        React.createElement(Typography, { variant: "subtitle1", sx: {
                fontWeight: 600,
                mb: 0.25,
            } }, typeof projectName === "string"
            ? smartTruncateString(projectName, 90)
            : projectName),
        subtitle && (React.createElement(Typography, { variant: "body2", sx: {
                color: "text.secondary",
                mb: 1.5,
            } }, isSearchResult && searchTerm && searchTerm.trim() !== ""
            ? highlightText(subtitle, searchTerm)
            : subtitle)),
        React.createElement(Box, { sx: { display: "flex", gap: 3, mb: 1.5 } },
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "caption", sx: {
                        color: "text.secondary",
                        display: "block",
                    } }, "Aanneemsom"),
                React.createElement(Typography, { variant: "body2", sx: {
                        fontWeight: 600,
                    } }, fmtNumber(aanneemsom))),
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "caption", sx: {
                        color: "text.secondary",
                        display: "block",
                    } }, "Omzet"),
                React.createElement(Typography, { variant: "body2", sx: {
                        fontWeight: 600,
                    } }, fmtNumber(omzet)))),
        React.createElement(Box, { sx: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1.25,
            } },
            React.createElement(Box, null, forecastMargin != null && (React.createElement(Chip, { label: `${fmtNumber(forecastMargin)} Forecast Merge`, size: "small", sx: Object.assign({ borderRadius: "24px" }, STATUS_STYLES.primary) }))),
            React.createElement(Box, null, projectStatus && projectStatus.trim() !== "" && (React.createElement(Chip, { label: projectStatus, size: "small", sx: Object.assign({ borderRadius: "24px" }, STATUS_STYLES[getStatusColor(projectStatus)]) })))),
        percent != null ? (React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 1 } },
            React.createElement(Box, { sx: { flex: 1 } },
                React.createElement(StatProgressBar, { value: "", label: "", percent: percent, color: "#4DB6F6", bgColor: "#E3F2FD", height: 8, labelFontWeight: 400, labelFonts: "h4", labelColor: "#3192D0" })),
            React.createElement(Typography, { variant: "body2", sx: {
                    color: "text.secondary",
                    minWidth: 32,
                    textAlign: "right",
                } }, formatPercent(percent)))) : (React.createElement(Tooltip, { title: "POC% is alleen zichtbaar op waarderingsniveau 1.", arrow: true, placement: "top" },
            React.createElement(Typography, { variant: "body2", sx: { cursor: "help" } }, "NB")))));
};
